var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-submit-component"},[_c('v-btn',{staticClass:"btn-submit",attrs:{"depressed":"","block":"","to":_vm.routeLink,"color":_vm.colorValue}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.valueBtn)+" ")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }